import memoize from "lodash/memoize";

const getFirstVideoIndex = (medias: Vingle.CardContent.MediaData[]): number => {
  for (let i = 0; i < medias.length; i++) {
    if (medias[i].type === "video") {
      return i;
    }
  }
  return -1;
};

export default memoize(getFirstVideoIndex);
